module.exports = __webpack_public_path__ + "img/logo.f93709a6.webp";